"use client";
import React from "react";
import { Linkedin, Facebook, InstagramIcon } from "lucide-react";
import Link from "next/link";
import { useTranslations } from "next-intl";
import { slugify } from "@/utils/commonFuncs";
import minesJSON from "@/data/mines.json";
import productsJSON from "@/data/products.json";
import { useParams } from "next/navigation";
import ResponsiveImage from "./ResponsiveImage";

function Footer({ hFull = false }) {
    const t = useTranslations("Footer");
    const t_c = useTranslations("Contact");
    const { locale } = useParams();

    const setSlug = (id, name) => {
        return id.toString() + "-" + slugify(name);
    };

    return (
        <footer
            className="w-full bg-[#151a38] md:px-10 p-4 pt-10 max-w-screen-2x1 mx-auto text-white overflow-scroll"
            style={{ height: hFull ? "100vh" : "fit-content" }}
        >
            <div className="my-12 flex flex-col md:flex-row gap-10">
                <div className="md:w-1/3 space-y-8">
                    {!hFull && (
                        <Link
                            href={"/" + locale + "/"}
                            className="text-2x1 font-semibold flex items-center space-x-3 text-primary"
                        >
                            <ResponsiveImage
                                src="/assets/logo/pomzaexport-logo-white.png"
                                alt="pomza export"
                                className="w-60 inline-block items-center"
                            />
                        </Link>
                    )}
                </div>
                {/* footer navigations */}
                <div className="md:w-2/3 flex flex-col md:flex-row flex-wrap justify-between gap-8 items-start">
                    {/* Mines */}
                    <div className="space-y-4 mt-4">
                        <h3 className="text-xl underline capitalize">
                            {t("facilities")}
                        </h3>
                        <ul className="space-y-3">
                            {minesJSON.map((item, key) => {
                                return (
                                    <li key={key}>
                                        <Link
                                            className="block hover:text-gray-300"
                                            href={
                                                "/" +
                                                locale +
                                                "/mine/" +
                                                setSlug(item.id, item.name[locale])
                                            }
                                        >
                                            {item.name[locale]}
                                        </Link>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>

                    {/* Products */}
                    <div className="space-y-4 mt-4">
                        <h3 className="text-xl underline capitalize">
                            {t("products")}
                        </h3>
                        <ul className="space-y-3">
                            {productsJSON.map((item, key) => {
                                return (
                                    <li key={key}>
                                        <Link
                                            className="block hover:text-gray-300"
                                            href={
                                                item.externalLink
                                                    ? item.link
                                                    : "/" +
                                                      locale +
                                                      "/product/" +
                                                      setSlug(
                                                          item.id,
                                                          item.name[locale]
                                                      )
                                            }
                                        >
                                            {item.name[locale]}
                                        </Link>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>

                    {/* Address */}
                    <div className="space-y-4 mt-4">
                        <h3 className="text-xl underline capitalize">
                            {t_c("contactAdresses")}
                        </h3>
                        <ul className="space-y-5 text-sm">
                            <li className="hover:text-gray-300">
                                <strong className="uppercase">
                                    {t_c("sartMadenIsletmesi")}
                                </strong>
                                <br />
                                <span>Sart Mah. Pomza Sk. No: 40</span>

                                <br />
                                <span>Salihli/MANİSA</span>

                                <br />
                                <span className="capitalize">
                                    {t_c("telephone")}
                                </span>
                                <span>: +90 236 724 20 21</span>
                                <br />
                                <span className="capitalize">{t_c("fax")}</span>
                                <span>: +90 236 724 30 51</span>
                            </li>
                            <li className="hover:text-gray-300">
                                <strong className="uppercase">
                                    {t_c("menderesMadenIsletmesi")}
                                </strong>
                                <br />
                                <span>Küner Mah. 7801 Sk. No:94</span>
                                <br />
                                <span> Menderes/İZMİR</span>
                                <br />
                                <span className="capitalize">
                                    {t_c("telephone")}
                                </span>{" "}
                                <span>: +90 232 782 14 46</span>
                                <br />
                                <span className="capitalize">
                                    {t_c("fax")}
                                </span>{" "}
                                <span>: +90 232 782 15 98</span>
                            </li>
                            <li className="hover:text-gray-300">
                                <strong className="uppercase">
                                    {t_c("etiperPerlitIsletmesi")}
                                </strong>
                                <br />
                                <span>
                                    Yeniköy Mah. Menderes - Orhanlı Yolu Sk. No:
                                    179/22 <br /> Menderes/İZMİR
                                </span>
                                <br />
                                <span className="capitalize">
                                    {t_c("telephone")}
                                </span>{" "}
                                <span>: +90 232 782 67 24</span>
                                <br />
                                <span className="capitalize">
                                    {t_c("fax")}
                                </span>{" "}
                                <span>: +90 232 782 67 25</span>
                            </li>
                            <li className="hover:text-gray-300">
                                <strong className="uppercase">
                                    {t_c("eilePomex")}
                                </strong>
                                <br />
                                <span>
                                    Yeniköy Mah. Menderes - Orhanlı Yolu Sk. No:
                                    179/26
                                </span>
                                <br />
                                <span>Menderes/İZMİR</span>
                                <br />
                                <span className="capitalize">
                                    {t_c("telephone")}
                                </span>{" "}
                                <span>: +90 232 360 17 77</span>
                                <br />
                                <span className="capitalize">
                                    {t_c("fax")}
                                </span>{" "}
                                <span>: +90 232 360 16 16</span>
                            </li>
                            <li className="hover:text-gray-300">
                                <strong className="uppercase">
                                    {t_c("ankaraOffice")}
                                </strong>
                                <br />
                                <span>Çukurca Birlik Mah. 447 Sk. No: 3/5</span>
                                <br />
                                <span>Çankaya/ANKARA</span>
                                <br />
                                <span className="capitalize">
                                    {t_c("telephone")}
                                </span>{" "}
                                <span>: +90 312 495 64 90</span>
                                <br />
                                <span className="capitalize">
                                    {t_c("fax")}
                                </span>{" "}
                                <span>: +90 312 495 64 93</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <hr />

            {/* Social Media */}
            <div className="flex flex-col sm:flex-row gap-8 sm:items-center justify-between my-8">
                <p className="capitalize">{t("copyright")}</p>
                <div className="flex items-center space-x-5">
                    <Link
                        href="https://www.linkedin.com/company/pomzaexport/"
                        target="_blank"
                        aria-label="LinkedIn"
                        className="w-8 cursor-pointer hover:-translate-y-1 transition-all duration-300"
                    >
                        <Linkedin />
                    </Link>
                    <Link
                        href="https://www.facebook.com/61565487748657"
                        target="_blank"
                        aria-label="Facebook"
                        className="w-8 cursor-pointer hover:-translate-y-1 transition-all duration-300"
                    >
                        <Facebook />
                    </Link>
                    <Link
                        href="https://www.instagram.com/pomza.exportt"
                        target="_blank"
                        aria-label="Instagram"
                        className="w-8 cursor-pointer hover:-translate-y-1 transition-all duration-300"
                    >
                        <InstagramIcon />
                    </Link>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
